import { ActivityIndicator, SxProp, View } from 'dripsy';
import React, { useEffect } from 'react';
import { RootStackRoutes } from 'types';
import { ExchangeSubAccountStackRoutes } from '../../exchange.navigator';
import { useGetUser } from '../../hooks/useGetUser.hook';
import { useNavigatorPage } from '../../hooks/useNavigatorPage.hook';
import ExchangeImageBackground from '../background/exchange-image-background';

export interface ExchangeSplashProps {}

export const ExchangeSplashScreen: React.FC<ExchangeSplashProps> = () => {
  const navigator = useNavigatorPage();
  const { profileData, isLoading, isSuccess } = useGetUser();

  useEffect(() => {
    if (!isLoading && isSuccess) {
      if (!!profileData?.metadata?.exchangeSubAccount) {
        if (!profileData.metadata.exchangeSubAccount.enabled && profileData.metadata.exchangeSubAccount.accountOpeningRequestedAt) {
          navigator.replaceScreen(RootStackRoutes.ExchangeSubAccount, ExchangeSubAccountStackRoutes.InstructionSubmitted);
        }
        if (!!profileData.metadata.exchangeSubAccount.enabled) {
          navigator.replaceScreen(RootStackRoutes.ExchangeSubAccount, ExchangeSubAccountStackRoutes.SelectExchange);
        }
      } else {
        navigator.replaceScreen(RootStackRoutes.ExchangeSubAccount, ExchangeSubAccountStackRoutes.Introduction);
      }
    }
  }, [profileData, isLoading]);

  return (
    <View sx={sxStyles.container}>
      <ExchangeImageBackground />
      <View sx={sxStyles.mainView}>{isLoading && <ActivityIndicator size={'large'} />}</View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    flex: 1
  },
  mainView: {
    height: '100%',
    alignItems: 'center',
    pt: 25
  }
};
